import { useState, useEffect } from "react";
import Config from "../../Config";

import InputText from "../../helpers/InputText";
import InputDecimal from "../../helpers/InputDecimal";
import InputTextArea from "../../helpers/InputTextArea";
import InputChecbox from "../../helpers/InputCheckbox";

import PlTitle from "../../elements/PlTitle";
import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputComboGrupa from "../../helpers/InputComboGrupa";
import InputPESEL from "../../helpers/InputPESEL";
import InputDate from "../../helpers/InputDate";
import InputPhone from "../../helpers/InputPhone";
import InputEmail from "../../helpers/InputEmail";
import InputCombo from "../../helpers/InputCombo";
import InputSearchKid from "../../helpers/InputSearchKid";
import InputPostCode from "../../helpers/InputPostCode";
import InputNIP from "../../helpers/InputNIP";

import InputUploader from "../../helpers/InputUploader";
import userx from "../../user.png"


import back from "../../back.png";


function EmpNew(props)
{
    const [errTab, setErrTab] = useState([]);  //z info od serwera..

    const [row, setRowX] = useState({

        crypt: '',

        imie: "",      
        nazwisko: "",
        ulica: "",
        nr_domu: "",
        nr_mieszkania: "",
        kod_pocztowy: "",
        miasto: "",
        telefon: "",
        email: '',

        typ_uzytkownika: 'OPIEKUN',
        opis: '',


        umowa_pracownika_od: '',
        umowa_pracownika_do: '',

        waznosc_badan_prac_od: '',
        waznosc_badan_prac_do: '',

        waznosc_badan_bhp_od: '',
        waznosc_badan_bhp_do: '',

        grupy: [],

    });

    var tmpRow = row;


    const [b64, setB64] = useState( userx );

    const [plgr, setPlGr] = useState(null);



    const valChecker = (fields) => {

        var allValid = true;

              
        console.log(JSON.stringify(fields) );

        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];                    

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }


    const valChangeListener = (filedName, val, correct, msg) => {         
        //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg); 
        var tabCheck = filedName.split('@');
        if(tabCheck.length == 2)
        {
            var tabName = tabCheck[0];
            var tabInx  = tabCheck[1];
            var tRef = row[tabName];  

         //   console.log("tRef", tRef);
           
            if(  tRef[tabInx] == "" || tRef[tabInx] == undefined )
            {
              tRef[tabInx] = val;
            }else tRef[tabInx] = '';


            tmpRow[tabName] = tRef;     
            setRowX(  JSON.parse(JSON.stringify(tmpRow)) );  

            //setRowX( {...row, [tabName]:tRef } );   
            return;
        }

      
        tmpRow[filedName] = val;
        tmpRow[filedName+"_valid"] = correct;         
        setRowX(  JSON.parse(JSON.stringify(tmpRow)) );            
        //setRowX( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );      
    }   


    const goNextNew = () => {
        console.log("goNext");
        saveData();
    }


    const [checked, setChecked] = useState(false);
    const handleChange = () => {
        setChecked(!checked);
      };

    
    const saveData = () => {


         
        if(!valChecker(row))
        {
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
            return;
        }
    

        props.mainView.setProgress(-2);

      

        

        var req = row;

        fetch( Config.url + '/rest_v1_emps,emp_add', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {             
                    
                    props.mainView.setProgress(-1);

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                       // props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                       setErrTab(res.result);
                    }else
                    if(res.status != undefined && res.status == "OK")
                    {
                        props.mainView.showDialog( "Sukces",  "Pracownik został dodany", "ok" , null);         
                        
                        Config.removeFromBuffer( Config.cache_kids_search, props.userData );
                        
                        props.onBack();
                    }else
                    {
                        props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                    }
                   
         } )
         .catch(err => {   
                    props.mainView.setProgress(-1);       
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
         });
                   

         return false;

    }



    const getImageByCrypt = (crypt) => {

  
        props.mainView.setProgress(-2);

      

        

        var req = {
            crypt: crypt,
            typ_id: -1,
            typ: 'none',
            thumb: 1,
            merge: 0,
        }

        fetch( Config.url + '/rest_v1,get_by', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {             
                    
                    props.mainView.setProgress(-1);

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                       // props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                       setErrTab(res.result);
                    }else
                    if(res.status != undefined && res.status == "OK")
                    {
                        if(res.result.list.length >0)
                            {
                                var b64 = res.result.list[0].b64;
                             
                                setRowX( {...row, ["crypt"]:crypt } );   
                                setB64( "data:image/png;base64," +b64);

                            }
                                                
                    }else
                    {
                        props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                    }
                   
         } )
         .catch(err => {   
                    props.mainView.setProgress(-1);       
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
         });
                   
         return false;
    }


    const completeUpload = (fileName, crypt) => {    
        console.log("completeUpload " + fileName + " " + crypt);
          
          getImageByCrypt(crypt);  
    }


    var role = [
        {
            v: "OPIEKUN",
            title: "Opiekun"
        },
        {
            v: "PRACOWNIK_BIUROWY",
            title: "Pracownik biurowy"
        },
        {
            v: "SPRZATACZKA",
            title: "Sprzątaczka"
        },
        {
            v: "WOZNY",
            title: "Woźny"
        },
        {
            v: "INTENDENT",
            title: "Intendent"
        },
        {
            v: "Nauczyciel",
            title: "Nauczyciel"
        },     
        {
            v: "POMOC NAUCZYCIELA",
            title: "Pomoc nauczyciela"
        }, 
        {
            v: "POMOC TECHNICZNA",
            title: "Pomoc techniczna"
        },    
        {
            v: "POMOC TECHNICZNA, KOORDYNATOR",
            title: "Pomoc techniczna - koordynator"
        },    
        {
            v: "KONSERWATOR",
            title: "Konserwator"
        },    
        {
            v: "KUCHNIA",
            title: "Kuchnia"
        },                                        
        
    ];




    const getGroup = () => {

        
        var req = {
        
        };

        fetch( Config.url + '/rest_v1_emps,kid_group', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {             
                    setPlGr(res); 
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
         });
                   

         return false;
    }


    if(plgr == null)
        {
            getGroup();
            return <div>
                ...
            </div>
        }



    return (
      
        <div className="view_content">

                    <img src={back} onClick={props.onBack} className="back_img" title="wstecz"/>


                      <form className="eForm bg_center">
                         
                                <div className="form_tab">


                                        <div className="change_img_profile">
                                          <img src={b64} />
                                          <InputUploader   userData={props.userData}  typ="none" typId="-1" remove="0" completeUpload={completeUpload} title="wybierz zdjęcie profilowe" max_files="1" ext="image/png, image/jpeg" />
                                        </div>

                                       <div className="form_split"></div>



                                        <div className="form_control">
                                                    <div className="fieldName">Rola</div>
                                                    <InputCombo  items={role} userData={props.userData} value={row.typ_uzytkownika} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="typ_uzytkownika" placeholder={"Typ:"} className=' w100 ' req='1'   />
                                        </div>


                                       <div className="form_control">
                                                    <div className="fieldName">Imię*</div>
                                                    <InputTextAlpha   userData={props.userData} value={row.imie} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="imie" placeholder={"Imię:"} className=' w100 ' req='1' firstUp="1" />
                                        </div>


                                        <div className="form_control">
                                                <div className="fieldName">Nazwisko*</div>
                                                <InputTextAlpha   userData={props.userData} value={row.nazwisko} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="nazwisko" placeholder={"Nazwisko:"} className=' w100 ' req='1' firstUp="1" />
                                       </div>



                                       <div className="form_split"></div>



                                        <div className="form_control">
                                                    <div className="fieldName">Ulica</div>
                                                    <InputText  userData={props.userData} value={row.ulica} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="ulica" placeholder={"Ulica:"} className=' w200 ' req='0'  />
                                        </div>

                                        <div className="form_control">
                                                    <div className="fieldName">Nr domu</div>
                                                    <InputText  userData={props.userData} value={row.nr_domu} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="nr_domu" placeholder={"Nr domu:"} className=' w100 ' req='0'  />
                                        </div>

                                        <div className="form_control">
                                                    <div className="fieldName">Nr mieszkania</div>
                                                    <InputText  userData={props.userData} value={row.nr_mieszkania} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="nr_mieszkania" placeholder={"Nr mieszkania:"} className=' w100 ' req='0'  />
                                        </div>

                                    

                                        <div className="form_control">
                                                    <div className="fieldName">Kod pocztowy</div>
                                                    <InputPostCode  userData={props.userData} value={row.kod_pocztowy} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="kod_pocztowy" placeholder={"Kod pocztowy:"} className=' w100 ' req='0'  />
                                        </div>

                                        <div className="form_control">
                                                    <div className="fieldName">Miasto</div>
                                                    <InputText  userData={props.userData} value={row.miasto} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="miasto" placeholder={"Miasto:"} className=' w200 ' req='0'  />
                                        </div>

                                </div>


                                <div className="form_tab">


                                        <div className="form_control">
                                                    <div className="fieldName">Telefon</div>
                                                    <InputPhone   userData={props.userData} value={row.telefon} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="telefon" placeholder={"Telefon:"} className=' w100 ' req='1'  />
                                        </div>

                                        <div className="form_control">
                                                    <div className="fieldName">E-mail</div>
                                                    <InputEmail   userData={props.userData} value={row.email} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="email" placeholder={"E-mail:"} className=' w200 ' req='1'  />
                                        </div>

                                </div>




                               <div className="form_tab">
                                <div className="form_tab_title">Dostęp do:</div>
                                
                                        {
                                        plgr.result.map( (item, ix) => {                                        

                                            
                                                var ccc = false;

                                                for(var p=0; p<row.grupy.length; p++)
                                                {
                                                    if(    row.grupy[p]  ===   item.id  )   
                                                        {
                                                            ccc = true;  
                                                            break;                                            
                                                        }                                                   
                                                }
                                                                                             
                                                return (
                                                    <div className="form_control">     
                                                                                                    
                                                        <InputChecbox  title={item.nazwa}  err={errTab}  userData={props.userData}  checked={ccc} value={item.id} valChange={valChangeListener}  name={ "grupy@"+ix  }   className=' ' req='0' />
                                                    </div>
                                                )

                                        } )
                                    }
                             </div>


                                <div className="form_tab_title">Dodatkowe informacje:

                                    &nbsp; 
                                    <label className="switch" title={props.userData.dic.showmore}>                               
                                        <input type="checkbox" checked={checked}  onChange={handleChange}/>
                                        <span className="slider round"></span>
                                    </label>  
                                </div>

                                
                                { checked &&
                                    <div>
                                            <br/>
                                            <div className="form_split"></div>

                                          
                                            <div className="form_control">
                                                        <div className="fieldName">Umowa od</div>
                                                        <InputDate  userData={props.userData} value={row.umowa_pracownika_od} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="umowa_pracownika_od" placeholder={"Umowa od:"} className=' w150 ' req='0'  />
                                            </div>

                                            <div className="form_control">
                                                        <div className="fieldName">Umowa do (puste jeżeli czas nieokreślony)</div>
                                                        <InputDate  userData={props.userData} value={row.umowa_pracownika_do} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="umowa_pracownika_do" placeholder={"Umowa do:"} className=' w150 ' req='0'  />
                                            </div>



                                            <div className="form_split"></div>

                                          
                                            <div className="form_control">
                                                        <div className="fieldName">Ważność badań od</div>
                                                        <InputDate  userData={props.userData} value={row.waznosc_badan_prac_od} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="waznosc_badan_prac_od" placeholder={"Od:"} className=' w150 ' req='0'  />
                                            </div>

                                            <div className="form_control">
                                                        <div className="fieldName">Ważność badań do (puste jeżeli czas nieokreślony)</div>
                                                        <InputDate  userData={props.userData} value={row.waznosc_badan_prac_do} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="waznosc_badan_prac_do" placeholder={"Do:"} className=' w150 ' req='0'  />
                                            </div>



                                            <div className="form_split"></div>

                                          
                                            <div className="form_control">
                                                        <div className="fieldName">BHP od</div>
                                                        <InputDate  userData={props.userData} value={row.waznosc_badan_bhp_od} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="waznosc_badan_bhp_od" placeholder={"Od:"} className=' w150 ' req='0'  />
                                            </div>

                                            <div className="form_control">
                                                        <div className="fieldName">BHP do (puste jeżeli czas nieokreślony)</div>
                                                        <InputDate  userData={props.userData} value={row.waznosc_badan_bhp_do} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="waznosc_badan_bhp_do" placeholder={"Do:"} className=' w150 ' req='0'  />
                                            </div>



                                            <div className="form_split"></div>

                                            <div className="form_control">
                                                    <div className="fieldName">Inne informacje</div>
                                                    <InputTextArea  userData={props.userData} value={row.opis} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="opis" placeholder={"Inne informacje:"} className=' w300 ' req='0'  />
                                           </div>

                                    </div>
                                }




                                <div className="form_split"></div>
                                <br/>

                                <div className="form_btn">
                                        <div className="btn" onClick={saveData}>dodaj</div>
                                        &nbsp;&nbsp;
                                        <div className="btn" onClick={props.onBack}    > anuluj</div>
                                </div>

                      </form>

        </div>
    )
}

export default EmpNew;